import { render, staticRenderFns } from "./ShippingAddress2.vue?vue&type=template&id=7c80e859&scoped=true&"
import script from "./ShippingAddress2.vue?vue&type=script&lang=js&"
export * from "./ShippingAddress2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c80e859",
  null
  
)

export default component.exports